module.exports = __webpack_public_path__ + "img/plan.638b04f3.png";